<label *ngIf="uiModel.labelText" for="{{fieldId}}" class="uiLabel col-md-{{uiModel.labelSize}} {{uiModel.labelClass}}">
    <div class="span-label-container">
        <span>{{uiModel.labelText | translate}}</span>
        <span *ngIf="uiModel.required && uiModel.labelText && !uiModel.hideMandatoryMark">*</span>
    </div>
  <i *ngIf="uiModel.popover" class="{{uiModel.popover.icon}}"><div innerHtml="{{uiModel.popover.content | translate}}"></div></i>
</label>
